import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import ErrorIcon from "@material-ui/icons/Error";
import HelpIcon from "@material-ui/icons/Help";
import InfoIcon from "@material-ui/icons/Info";
import WarningIcon from "@material-ui/icons/Warning";
import React from "react";
import { SnackbarVariants } from "../constants";

interface SnackbarMessageIconProps {
  variant: SnackbarVariants;
  className?: string;
}

export const SnackbarMessageIconComponent = (props: SnackbarMessageIconProps) => {
  const { variant, className } = props;

  const Icon =
    variant === "info"
      ? InfoIcon
      : variant === "success"
      ? CheckCircleIcon
      : variant === "warning"
      ? WarningIcon
      : variant === "error"
      ? ErrorIcon
      : HelpIcon;

  return <Icon className={className} />;
};

export const SnackbarMessageIcon = SnackbarMessageIconComponent;
